import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=3a407da4&functional=true&"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\adviewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a407da4')) {
      api.createRecord('3a407da4', component.options)
    } else {
      api.rerender('3a407da4', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=3a407da4&functional=true&", function () {
      api.rerender('3a407da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/views/PageNotFound.vue"
export default component.exports